import Vue from 'vue';
import batchTransformer from '../../transformers/batch';
import store from '../../store';

const success = ({ data }) => batchTransformer.fetch(data);

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    const batchs = store.state.batch.items.filter(p => (
      id.toString() === p.id.toString()
    ));

    if (batchs.length > 0) {
      return resolve(batchs[0]);
    }

    return Vue.$http.get(`/production/batch/${id}`)
      .then((response) => {
        resolve(success(response));
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batch/show.js